export default __webpack_public_path__ + "static/media/delete.634eda10.svg";